import React, { Fragment } from 'react';

import { Link } from 'formlabs-web-components/Link';
import { GridContainer } from 'formlabs-web-components/Grid';

import './Breadcrumbs.module.css';

const Breadcrumbs = ({ entries }) => (
  <nav styleName="nav">
    <GridContainer>
      <ul>
        {entries.map((link, i) => (
          <li key={i}>
            {i < entries.length - 1 ? (
              <Fragment>
                <Link to={link.url}>{link.name}</Link>
                <span styleName="seperator">/</span>
              </Fragment>
            ) : (
              <span>{link.name}</span>
            )}
          </li>
        ))}
      </ul>
    </GridContainer>
  </nav>
);

export default Breadcrumbs;
